import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { leftEarlyShifts } from './keys'
import {
  getLeftEarlyShiftsForReview,
  GetLeftEarlyShiftsOptions,
  GetLeftEarlyShiftsResponse,
} from 'api/review'

export function useLeftEarlyShifts(
  options?: GetLeftEarlyShiftsOptions
): UseQueryResult<GetLeftEarlyShiftsResponse> {
  return useQuery<GetLeftEarlyShiftsResponse>({
    queryKey: [...leftEarlyShifts, options],
    queryFn: async () => {
      return getLeftEarlyShiftsForReview(options || {})
    },
  })
}
